/**
 * MyComment
 */

import List from '../List';
import Config from '../../Config';

class MyComment extends List {
  protected isUser: boolean;

  constructor(node: any, options: any) {
    Config.isShowSearchForm = false;
    Config.isWrite = false;
    Config.isShowReload = false;

    super(node, options);

    Config.userGuid = options.userGuid || '';
    Config.gameUserUid = options.gameUserUid || '';
    Config.gameCharacterId = options.gameCharacterId || '';
    Config.gameServerId = options.gameServerId || '';

    this.isUser = Config.guid && Config.userGuid === Config.guid ? false : true;

    if (Config.gameUserUid && Config.gameServerId) {
      this.isUser = true;
    }
  }

  public get(apiUrl: string) {
    const url = (apiUrl) ? apiUrl : Config.isInfinite ? Config.myMoreCommentArticle(this.isUser) : Config.myCommentArticle(this.isUser);
    super.get(url);
  }
}

export default MyComment;
